import gameData1 from './game1.json';
import gameData2 from './game2.json';
import gameData3 from './game3.json';
import gameData4 from './game4.json';

export const allGame1Cards = [
    ...gameData1.deckActionCardDraw.cards.map((card: { name: string }) => card.name),
    ...gameData1.deckActionDrawLeft.cards.map((card: { name: string }) => card.name),
    ...gameData1.deckActionDrawRight.cards.map((card: { name: string }) => card.name),
    ...gameData1.deckActionCardActive.cards.map((card: { name: string }) => card.name),
    gameData1.objectiveOne.name,
    gameData1.objectiveTwo.name,
    gameData1.objectiveThree.name,
  ];

export const gameDataObject1 = gameData1;
export const gameDataObject2 = gameData2;
export const gameDataObject3 = gameData3;
export const gameDataObject4 = gameData4;

export interface SavedCard {
    name: string;
}

export interface SavedDeck {
    cards: SavedCard[];
}

export interface SaveGameData {
    deckActionCardDraw: SavedDeck;
    deckActionCardDiscard: SavedDeck;
    deckActionDrawLeft: SavedDeck;
    deckActionDrawRight: SavedDeck;
    deckActionCardActive: SavedDeck;
    objectiveOne: { name: string };
    objectiveTwo: { name: string };
    objectiveThree: { name: string };
    randomSeed: { seed: number };
}


export function processGameData(gameData: SaveGameData) {
    console.log("Processing deckActionCardDraw:");
    gameData.deckActionCardDraw.cards.forEach(card => console.log(card.name));

    console.log("Processing deckActionDrawLeft:");
    gameData.deckActionDrawLeft.cards.forEach(card => console.log(card.name));

    console.log("Processing deckActionDrawRight:");
    gameData.deckActionDrawRight.cards.forEach(card => console.log(card.name));

    console.log("Processing deckActionCardActive:");
    gameData.deckActionCardActive.cards.forEach(card => console.log(card.name));

    // You can also access objectives or the random seed
    console.log("Objective One:", gameData.objectiveOne.name);
    console.log("Objective Two:", gameData.objectiveTwo.name);
    console.log("Objective Three:", gameData.objectiveThree.name);
    console.log("Random Seed:", gameData.randomSeed.seed);
}